import * as userActions from '../../reducers/user';
import Logger from '../../../services/Logger';
import sdk from '../../../sdk';
import Toast from '../../../components/Toast';
import l18n from '../../../shared/strings';

const saveTeamSetting = (key, value, options = {}) => async (dispatch, getState) => {
  const { user } = getState();
  const prevValue = user.team?.settings?.[key];

  dispatch(userActions.updateTeamSetting({ key, value }));

  try {
    await sdk.team.setTeamSettings(key, value);
    return true;
  } catch (err) {
    dispatch(userActions.updateTeamSetting({ key, value: prevValue }));
    Logger.error(new Error(`Can not update team setting - ${key}`), { error: err }, [
      'UpdateTeamSettingFailed',
      { errorMessage: (err && err.message) || 'NoMessage' },
    ]);
    if (!options.silent) {
      Toast(l18n.TEAMMATES.errorUpdateTeamSetting, { type: 'error' });
    }
    return false;
  }
};

export default saveTeamSetting;
